
import { categoryApi } from '../../../api/san-pham/categoryApi';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { ICategory } from '../../../model/respone/san-pham/ICategory';
import { eCategoryActionTypeIds, ICategoryActions } from '../../action-types/san-pham/ICategoryActionType';

import { rootActions } from '../../actions/rootActions';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
const mainAction = rootActions.sanPham.category;
export function* categorySaga(): any {
    yield takeLatest(eCategoryActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eCategoryActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eCategoryActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ICategoryActions): any {
    const res: IBaseRespone = yield call(categoryApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ICategoryActions): any {
    let res: IBaseRespone;
    const category = action.payload as ICategory;
    if (category.id > 0) {
        res = yield call(categoryApi.Update, category)
    } else {
        res = yield call(categoryApi.Insert, category)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ICategoryActions): any {
    const res: IBaseRespone = yield call(categoryApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}